import {DialogActions, styled} from '@mui/material';

const Footer = styled(DialogActions)`
	border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
	padding: 8px 16px;
`;

export {Footer};
